import { Auth } from 'features';
import { FioAccount } from 'features/fioAccount';
import Organizations from 'features/organizations';
import Divisions from 'features/divisions';
import style from './index.module.scss';

export const Header = () => (
  <header className={style.root}>
    <Organizations />
    <Divisions />
    <div className={style.accountWrap}>
      <FioAccount />
      <Auth.ByEmail.AccountDropdown />
    </div>
  </header>
);
